<template>
  <div class="ms-grid">
    <table class="table">
      <thead>
        <ms-grid-header
          :config="config"
          :columns="columns"
          @onSort="onSort"
          @onCheck="onCheckAll"
        />
      </thead>
      <tbody>
        <tr
          v-for="(item, $index) in data"
          :key="$index"
        >
          <td
            v-if="config.selectable"
            class="text-center"
            width="50"
          >
            <input
              v-model="item.$checked"
              type="checkbox"
            >
          </td>
          <td
            v-for="(column, $cindex) in columns"
            :key="$cindex"
            :class="columnClass(column)"
          >
            <slot
              :name="column.property"
              :row="item"
            >
              <router-link
                v-if="renderLink(column.link, item)"
                :to="column.link(item)"
              >
                {{ itemValue(item, column) }}
              </router-link>
              <template v-else>
                {{ itemValue(item, column) }}
              </template>
            </slot>
          </td>
          <td v-if="options.actions && options.actions.length">
            <ms-grid-actions
              :actions="options.actions"
              :row="item"
            />
          </td>
        </tr>
      </tbody>
    </table>

    <slot
      v-if="!data.length"
      name="no-content"
    >
      <div class="no-content">
        <i class="icon-alert-triangle"/>
        <h1>No se encontraron resultados</h1>
        <h5 v-if="addRegister">¿Desea agregar algun registro?</h5>
        <el-button
          v-if="addRegister"
          @click="clickOnNotFound">
          Agregar
        </el-button>
      </div>
    </slot>

    <ms-grid-pager
      v-if="visible"
      v-bind="pager"
      @changePage="onChangePage"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import MsGridHeader from './ms-grid-header'
import MsGridPager from './ms-grid-pager'
import MsGridActions from './ms-grid-actions'

export default {
  name: 'MsGrid',
  components: {
    MsGridHeader,
    MsGridPager,
    MsGridActions
  },
  props: {
    columns: {
      required: true,
      type: Array
    },
    data: {
      required: true,
      type: Array
    },
    options: {
      required: false,
      type: Object,
      default: () => {
        return {}
      }
    },
    pager: {
      type: Object,
      required: true,
      default () {
        return {
          total: 0,
          current: 1
        }
      }
    },
    addRegister: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      defaultOptions: {
        key: 'id', // The default key for indexing
        selectable: true
      }
    }
  },
  computed: {
    config () {
      return Object.assign(this.defaultOptions, this.options)
    }
  },
  methods: {
    clickOnNotFound () {
      this.$emit('notFoundItem')
    },
    columnClass (column) {
      if (column.align) {
        return 'text-' + column.align
      }
      return ''
    },
    onChangePage (page) {
      let query = Object.assign({}, this.$route.query)
      query.page = page
      this.$router.replace({query: query})
    },
    onCheckAll (value) {
      for (let i = 0; i < this.data.length; i++) {
        Vue.set(this.data[i], '$checked', value)
      }
    },
    onSort (payload) {
      let query = Object.assign({}, this.$route.query)
      query = {...this.$route.query, sort: payload.property + ' ' + payload.direction}
      query.sort = payload.property + ' ' + payload.direction
      this.$router.replace({query: query})
    },
    renderLink (fnc, item) {
      if (typeof fnc === 'function') {
        return fnc(item)
      } else {
        return fnc
      }
    },
    itemValue (item, column) {
      /**
         * Splits the column property to access
         * a child property in the item object,
         * no matter how deep the property is.
         *
         * For example, "dealer.branch.name"
         */
      let value = column.property.split('.')
        .reduce(function (a, b) {
          return a ? a[b] : null
        }, item)

      if (typeof column.filter === 'function') {
        value = column.filter(value)
      }

      /**
         * Sets the format of the output
         */
      switch (column.type) {
        case 'number':
          return value
        case 'string':
          return value
        case 'date':
          if (value) {
            return moment(value).format('DD/MM/YYYY')
          } else {
            return ''
          }
        case 'dateTime':
          return moment(value).format('DD/MM/YYYY HH:mm')
        default:
          return value
      }
    }
  }
}
</script>

<style lang="scss">
  /**
   * Se importan los iconos
   */
  @import url(./assets/style.css);

  .ms-grid {

  }

  .no-content {
    background-color: #fff;
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    min-height: 40vh;
    width: 100%;
    justify-content: center;
    align-items: center;
    i{
      font-size: 60px;
      color: $icon;
    }
    h1 {
      font-size: 22px;
    }
    .el-button{
      background-color: $primary;
      color: #ffffff;
    }
  }

  .text-center {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/modules/grid/ms-grid.vue